<template>
  <master-page>
    <br/>
    <v-card>
      <v-card-title>        
        <v-icon large left>mdi-bank-check</v-icon>
        <span class="title font-weight-light">Conciliação Bancária</span>

        <v-spacer/>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="mr-4" color="primary" @click="AbrirDialogConciliacao()" v-on="on" :disabled="!valid">mdi-bank-check</v-icon>
          </template>
          <span>Conciliar</span>
        </v-tooltip>

        <v-expansion-panels focusable v-model="panel" class="mt-4">
          <v-expansion-panel>
            <v-expansion-panel-header>Filtros</v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-form id="form" ref="form" v-model="valid" lazy-validation >
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-autocomplete v-model="filtro.bancoId" :items="bancos" item-text="codigoNome" item-value="id" label="Banco" placeholder="Selecione um banco" :rules="fieldRules" dense outlined/>
                    </v-col>
                    <v-spacer/>
                    <v-col cols="12" md="2">
                      <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                        <template v-slot:activator="{on}">
                          <v-text-field type="date" v-model="filtro.dataInicial" label="Data Inicial" :rules="fieldRules" dense outlined>
                            <template v-slot:prepend>
                              <v-icon v-on="on">mdi-calendar</v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker locale="pt-br" v-model="filtro.dataInicial" no-title/>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="1">
                      <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.dataFinal" label="Data Final" :rules="fieldRules" prepend-icon="mdi-calendar" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.dataFinal" no-title/>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row>
                  <v-spacer/>
                  <v-btn color="accent" @click="Listar()" :disabled="!valid">Consultar</v-btn>
                </v-row>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <b>Saldo Inicial: {{ extrato ? extrato.saldoInicial.toMoeda(true) : 0 }}</b>
          </v-col>
          <v-col cols="12" md="3">
            <b>Saídas: {{ extrato ? extrato.totalSaida.toMoeda(true) : 0 }}</b>
          </v-col>
          <v-col cols="12" md="3">
            <b>Entradas: {{ extrato ? extrato.totalEntrada.toMoeda(true) : 0 }}</b>
          </v-col>
          <v-col cols="12" md="3">
            <b>Saldo Atual: {{ extrato ? extrato.saldoAtual.toMoeda(true) : 0 }}</b>
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Conciliado</th>
                <th class="text-left">Código</th>
                <th class="text-left">Data</th>
                <th class="text-left">Descrição</th>
                <th class="text-left">Entrada</th>
                <th class="text-left">Saída</th>
              </tr>
            </thead>
            <tbody v-if="extrato">
              <tr v-for="item in extrato.items" :key="item.id">
                <td>
                  <v-checkbox v-model="item.conciliado" dense @click.prevent="Conciliar(item)"/>
                </td>
                <td>{{ item.idFluxoBancario }}</td>
                <td>{{ new Date(item.data).ddmmyyyy() }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ item.credito.toMoeda() }}</td>
                <td>{{ item.debito.toMoeda() }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <!-- CONCILIACAO -->
    <cadastro-conciliacaoBancaria v-model="dialogConciliacao" :filtro="filtro" @fechou="dialogConciliacao = false"/>

    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </master-page>
</template>

<script>
import FluxoBancarioService from '@/core/services/financeiro/FluxoBancarioService';
import BancoService from '@/core/services/financeiro/BancoService';
import { EmpresaService } from '../../../core/services/geral';

export default {
  data() {
    return {
      extrato: null,      
      service: new FluxoBancarioService(),
      empresaService: new EmpresaService(),
      valid: true,
      fieldRules: [
        v => !!v || 'Campo obrigatório'
      ],
      isLoading: false,
      filtro: {
        bancoId: null,
        dataInicial: new Date(new Date().getFullYear(), new Date().getMonth(), 1).yyyymmdd(),
        dataFinal: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).yyyymmdd()
      },
      panel: 0,
      bancos: [],
      dialogConciliacao: false
    }
  },
  methods: {
    Listar(){
      if(this.$refs.form.validate()){
        this.isLoading = true;
        this.service.ListarComFiltro(this.filtro).then(
          res => {
            this.extrato = res.data;
          },
          err => {
            this.$swal('Aviso', err.response.data, 'error')
          }
        ).finally(() => {
          this.isLoading = false;
        });
      }
    },
    AbrirDialogConciliacao(){
      if(this.$refs.form.validate()){
        this.dialogConciliacao = true;
      }
    },
    Conciliar(item){
      if(!this.isLoading){
        this.isLoading = true;
        item.conciliado = !item.conciliado;
        let model = [
          {
            id: item.idFluxoBancario,
            conciliado: item.conciliado
          }
        ]
        this.service.Conciliar(model).then(
          res => {
            this.$swal('Aviso', 'Operação realizada com sucesso!', 'success')
            this.Listar();
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        ).finally(() => this.isLoading = false)
      }
    }
  },
  created(){
    
  },
  mounted() {
    if ('form' in this.$refs)
      this.$refs.form.resetValidation();

    let bancoService = new BancoService();
    bancoService.Listar().then(
      res => {
        const bancoDireto = res.data.items;
        this.bancos = bancoDireto.filter(x => x.situacao == 'A');
      },
      err => this.$swal('Aviso', err.message, 'error')
    );
  }
}
</script>
